import React, { PropsWithChildren } from 'react';

export const ContainerWithMaxWidth: React.FC<PropsWithChildren<{ noPaddingXMobile?: boolean; className?: string }>> = ({ children, noPaddingXMobile, className = '' }) => {
  return <div className={`max-w-[1344px] ${noPaddingXMobile ? '' : 'px-4 md:px-6'} mx-auto xl:px-24 ${className}`}>{children}</div>;
};
